export const excludedPatterns = [
  'Viewer3D',
  'SimSave',
  'Viewer',
  'DICOM',
  'Embedded',
  'SandboxViewer'
]
